import { TablePagination } from "../../../components";
import DashboardSharedTable from "./common/DashboardSharedTable";
import HistogramToggleButton from "./common/HistogramToggleButton";
import XModal from "../../../components/common/XModal";
import Histogram from "./Histogram";
import useCompanyModalState from "./hooks/useCompanyModalState";

const CompaniesModal = ({ open, configKey, dashboardData, isLoading, onClose }) => {
  const {
    title,
    columns,
    histogramDataKey,
    isHistogramView,
    toggleView,
    companies,
    paginatedData,
    paginationProps
  } = useCompanyModalState({ open, configKey, dashboardData });

  if (!configKey) return null;

  return (
    <XModal
      isOpen={open}
      title={title}
      onClose={onClose}
      headerAction={
        histogramDataKey && (
          <HistogramToggleButton isHistogramView={isHistogramView} onToggle={toggleView} />
        )
      }
    >
      {isLoading ? (
        <div className="text-center py-6">Loading...</div>
      ) : (
        <>
          {isHistogramView ? (
            <Histogram selectedDataKey={histogramDataKey} data={companies} />
          ) : (
            <>
              <DashboardSharedTable
                title={null}
                columns={columns || []}
                data={paginatedData}
                className="flex flex-col pb-4 gap-2.5 rounded-lg bg-surface-alt"
                hasScroll={true}
              />
              <TablePagination {...paginationProps} />
            </>
          )}
        </>
      )}
    </XModal>
  );
};

export default CompaniesModal;
